import React, { Component } from 'react';
import { store, App, Provider } from './js/';


class AddressSearch extends Component {
  render() {
    return (
      <Provider store={store}>
          <App {...this.props} />
      </Provider>
    );
  }
}
export { AddressSearch };
